(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wgs-fall-candles"]) return;
  try {
    
function updateFallForm(form) {
  const select=form.querySelector('select[name="id"]');
  const option=select.options[select.selectedIndex];
  const available=option.dataset.available==='true';
  form.closest('.wgs-fall-card').querySelector('[data-fall-price]').textContent=option.dataset.price;
  const button=form.querySelector('button[type="submit"]');
  button.disabled=!available;
  button.textContent=available?form.dataset.addLabel:form.dataset.soldLabel;
}
function initializeFallForms(root) {
  root.querySelectorAll('.wgs-fall-form').forEach(form=>{
    if(form.dataset.initialized)return;
    form.dataset.initialized='true';
    form.querySelector('select').addEventListener('change',()=>updateFallForm(form));
    updateFallForm(form);
  });
}
initializeFallForms(document);
document.addEventListener('shopify:section:load',event=>initializeFallForms(event.target));

  } catch(e) { console.error(e); }
})();
})();
